import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';
import { SidebarMenuContainer } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-container.model';

@Component({
  selector: 'sidebar-item',
  templateUrl: './sidebar-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarItemComponent implements OnInit {
  @Input()
  public isCollapsed = false;

  @Input()
  public item: SidebarMenuItem | SidebarMenuContainer;

  public isContainer: boolean;

  public ngOnInit(): void {
    this.isContainer = this.item instanceof SidebarMenuContainer;
  }
}
